<template>
    <div>
        <app-error-dialog v-model="showError" title="Unable to export">
            There is no data to export.
        </app-error-dialog>

        <app-icon-button color="primary" icon="mdi-microsoft-excel" @click="exportToExcel" />
    </div>
</template>

<script>
import { excelExport } from "@/features/schemas/services/exporter";
import schemaMixin from "@/features/schemas/mixins/schemaMixin";

export default {
    mixins:[schemaMixin],

    props: {
        listRequest: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            showError: false
        }
    },
    methods: {
        async exportToExcel() {
            await excelExport(this.entityKey, this.listRequest);
        }
    }
}
</script>
